import { Dir } from '@angular/cdk/bidi';
import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { ClickStopPropagationDirective } from '@src/suite/common/directives/stop-propagation';
import { OPTION_BLANK } from '@src/suite/common/enums/constants';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { OpenFullscreenModalActions } from '@src/suite/common/store/fullscreen';
import { PlaybookApiActions } from '@src/suite/common/store/playbook/playbook.actions';
import { selectStoryTemplates } from '@src/suite/common/store/records/records.selectors';

import { BaseMainCtaComponent } from '../base-main-cta.component';

@Component({
    selector: 'st-playbook-main-cta',
    imports: [ClickStopPropagationDirective, Dir, MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule],
    templateUrl: './playbook-main-cta.component.html',
    styleUrl: './playbook-main-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-playbook-main-cta',
    },
})
export class PlaybookMainCtaComponent extends BaseMainCtaComponent {
    readonly optionBlank = OPTION_BLANK;

    readonly storyTemplates = this.store.selectSignal(selectStoryTemplates);

    readonly storyTemplatesDisabled = computed(() => {
        return !this.storyTemplates().length || !this.storyEditable;
    });

    readonly shouldHaveSeparateNewButtons = computed(() => {
        return !this.visualStateService.isLessThanSmall();
    });

    onNewStoryClicked() {
        this.store.dispatch(
            OpenFullscreenModalActions.initCreateNewRecordFullscreen({
                recordType: ObjectTypes.SCRIPT,
            })
        );
    }

    onStoryTemplateMenuOpened() {
        this.store.dispatch(PlaybookApiActions.loadStoryTemplates());
    }

    selectStoryTemplate(template: StorytellingStoryRecord) {
        if (!template.isDeleted) {
            if (template.Guid === OPTION_BLANK) {
                this.onNewStoryClicked();
            } else {
                this.store.dispatch(
                    OpenFullscreenModalActions.initCreateNewRecordFullscreen({
                        recordTemplate: template,
                        recordType: template.Type,
                    })
                );
            }
        }
    }
}
